<template>
    <v-card class="rating elevation-0">
        <v-card-title class="rating__name">
            {{ rating.rating_name }}
        </v-card-title>
        <div class="rating__content" v-bind:style="{justifyContent: ratingIsVoted ? 'space-between' : 'center'}">
            <span v-if="ratingIsVoted" class="rating__total">
                {{ rating.rating_total }}
            </span>
            <v-rating 
                color="yellow"
                :size="isLessThan600 ? 22 : 44"
                :ripple="false"
                v-model="value"
                :readonly="ratingIsVoted"
                :half-increments="ratingIsVoted"
            />
            <span v-if="ratingIsVoted" class="rating__count">
                {{ rating.rating_count }} total
            </span>
        </div>
    </v-card>
</template>
<script>
export default {
    props: {
        rating: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            value: 0
        }
    },
    computed: {
        ratingIsVoted() {
            return !!this.rating.vote
        },
        isLessThan600() {
            return this.$vuetify.breakpoint.width <= 600
        },
    },
    watch: {
        value(newValue) {
            if (!this.rating.vote) {
                this.$emit('ratingChange', {rating_id: this.rating.rating_id, rating: newValue})
            }
        }
    },
    created() {
        if (this.rating.vote) {
            this.value = this.rating.rating_total
        }
    }
}
</script>
<style lang="scss">
.rating {
    background-color: #F3F3F6 !important;
    border: 1px solid #E2E2E2 !important;
    border-radius: 10px !important;
    padding: 16px;
    margin-bottom: 12px;
    font-family: Montserrat, sans-serif;

    &__content {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
    }

    &__name {
        font-size: 18px;
        font-weight: 700;
        color: var(--accent-color);
        line-height: 21.94px;
        padding: 0 !important;
    }

    &__total {
        font-size: 24px;
        font-weight: 700;
        color: var(--accent-color);
        line-height: 29.26px;

        @media (max-width: 480px) {
            font-size: 16px;
        }
    }

    &__count {
        font-size: 16px;
        font-weight: 500;
        line-height: 19.5px;
        color: #9B9B9B;

        @media (max-width: 480px) {
            font-size: 12px;
        }
    }

    .v-rating {
        display: flex;
        flex-wrap: nowrap;
        justify-content: center;
    }

    .accent--text::before {
        color: #E2E2E2 !important;
    }
}
</style>